module.exports = __webpack_public_path__ + "static/media/Junghunde02.e9ecb279.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Junghunde02.jpg
// module id = 337
// module chunks = 0